export const getCurrentSetScoreAndIndex = (setScores: number[]) => {
  let currentIndex = 0;
  // TODO: maybe refactor -- is it just the last item in the array?
  // eslint-disable-next-line no-unreachable-loop
  for (let i = 0; i < setScores.length; i += 1) {
    const index = setScores.length - 1 - i;

    currentIndex = index;
    break;
  }

  let currentScore = setScores[currentIndex];
  if (currentScore === -1) {
    currentScore = 0;
  }

  return { currentScore, currentIndex };
};

export const getCurrentPeriodScoreAndIndex = (periodScores: number[]) => {
  let currentIndex = 0;
  // TODO: maybe refactor -- is it just the last item in the array?
  // eslint-disable-next-line no-unreachable-loop
  for (let i = 0; i < periodScores.length; i += 1) {
    const index = periodScores.length - 1 - i;

    currentIndex = index;
    break;
  }

  let currentScore = periodScores[currentIndex];
  if (currentScore === -1) {
    currentScore = 0;
  }

  return { currentScore, currentIndex };
};

export const getMatchScores = (
  teamASetScores: number[],
  teamHSetScores: number[]
) => {
  let homeScore = 0;
  let awayScore = 0;
  if (
    teamASetScores &&
    teamHSetScores &&
    teamASetScores.length > 0 &&
    teamHSetScores.length > 0
  ) {
    Array.from(Array(teamASetScores.length - 1).keys()).forEach((i) => {
      const awaySetScore = teamASetScores[i];
      const homeSetScore = teamHSetScores[i];

      if (homeSetScore >= 0 && awaySetScore >= 0) {
        if (homeSetScore > awaySetScore) {
          homeScore += 1;
        } else if (homeSetScore < awaySetScore) {
          awayScore += 1;
        }
      }
    });
  }

  return {
    teamAMatchScore: awayScore,
    teamHMatchScore: homeScore,
  };
};
